/* -- set app title --*/
const AppTitle = 'SellAgent';

/* -- set app mode -- */
const AppMode = ['', 'development', 'production', 'testing'];

/* -- set API URLs --*/
let testing = 'https://server.sellagent.ai';
let development = 'https://server.sellagent.ai';
let production = 'https://pserver.sellagent.ai';

let ApiUrl;
switch (AppMode[2]) {
  case 'development':
    ApiUrl = development;
    break;
  case 'production':
    ApiUrl = production;
    break;
  case 'testing':
    ApiUrl = testing;
    break;
  default:
    ApiUrl = 'http://localhost:4005';
}
console.log('************* ApiUrl = ', ApiUrl);

// OAuth Configuration
const oauthConfig = {
  google: {
    clientId: process['env']['REACT_APP_GOOGLE_CLIENT_ID'] || 'YOUR_GOOGLE_CLIENT_ID',
    redirectUri: process['env']['REACT_APP_REDIRECT_URI'] || window['location']['origin'],
  },
  microsoft: {
    clientId: process['env']['REACT_APP_MICROSOFT_CLIENT_ID'] || 'YOUR_MICROSOFT_CLIENT_ID',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: process['env']['REACT_APP_REDIRECT_URI'] || window['location']['origin'],
    scopes: ['user.read', 'profile', 'email', 'openid'],
  },
  apple: {
    clientId: process['env']['REACT_APP_APPLE_CLIENT_ID'] || 'YOUR_APPLE_CLIENT_ID',
    redirectUri: process['env']['REACT_APP_REDIRECT_URI'] || window['location']['origin'],
    scope: 'email name',
  }
}

ApiUrl = `${ApiUrl}/api`;

// LangGraph API Configuration
const LangGraphApiUrl = `${ApiUrl}/automation/workflows`;

// GTM Tracking Mode Configuration
// 0 = Track ALL users (organic + tracking_id users)
// 1 = Track ONLY users with tracking_id (paid campaigns only, exclude organic/direct)
export const GTM_TRACK_MODE = 0; // Set to 1 for production (tracking only), 0 for all users

export { AppTitle, ApiUrl, LangGraphApiUrl, oauthConfig };
